import { render, staticRenderFns } from "./DebtorEdit.vue?vue&type=template&id=3284846c&"
import script from "./DebtorEdit.vue?vue&type=script&lang=js&"
export * from "./DebtorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports